import { render, staticRenderFns } from "./ModalOxapayBalance.vue?vue&type=template&id=ae11d5cc&scoped=true"
import script from "./ModalOxapayBalance.vue?vue&type=script&lang=js"
export * from "./ModalOxapayBalance.vue?vue&type=script&lang=js"
import style0 from "./ModalOxapayBalance.vue?vue&type=style&index=0&id=ae11d5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae11d5cc",
  null
  
)

export default component.exports